// Module
var code = "<div ref=\"container\" class=\"form-select\" tabindex=\"0\"></div>";
// Exports
module.exports = code;